module.exports = __webpack_public_path__ + "img/bitrix--OLD.eb78abff.svg";